/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimEmailAttachment } from './ClaimEmailAttachment';
import {
    ClaimEmailAttachmentFromJSON,
    ClaimEmailAttachmentFromJSONTyped,
    ClaimEmailAttachmentToJSON,
    ClaimEmailAttachmentToJSONTyped,
} from './ClaimEmailAttachment';
import type { ClaimEmailRecipient } from './ClaimEmailRecipient';
import {
    ClaimEmailRecipientFromJSON,
    ClaimEmailRecipientFromJSONTyped,
    ClaimEmailRecipientToJSON,
    ClaimEmailRecipientToJSONTyped,
} from './ClaimEmailRecipient';
import type { EmailDirection } from './EmailDirection';
import {
    EmailDirectionFromJSON,
    EmailDirectionFromJSONTyped,
    EmailDirectionToJSON,
    EmailDirectionToJSONTyped,
} from './EmailDirection';
import type { EmailStatus } from './EmailStatus';
import {
    EmailStatusFromJSON,
    EmailStatusFromJSONTyped,
    EmailStatusToJSON,
    EmailStatusToJSONTyped,
} from './EmailStatus';

/**
 * 
 * @export
 * @interface ClaimEmailWithRecipients
 */
export interface ClaimEmailWithRecipients {
    /**
     * 
     * @type {number}
     * @memberof ClaimEmailWithRecipients
     */
    readonly id: number;
    /**
     * ID of the claim this email belongs to
     * @type {number}
     * @memberof ClaimEmailWithRecipients
     */
    claimId: number;
    /**
     * Company that owns this email
     * @type {number}
     * @memberof ClaimEmailWithRecipients
     */
    companyId: number;
    /**
     * User who sent the email
     * @type {number}
     * @memberof ClaimEmailWithRecipients
     */
    senderUserId: number;
    /**
     * Gmail account used to send
     * @type {number}
     * @memberof ClaimEmailWithRecipients
     */
    gmailAccountId?: number | null;
    /**
     * 
     * @type {EmailDirection}
     * @memberof ClaimEmailWithRecipients
     */
    direction: EmailDirection;
    /**
     * Email subject line
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    subject: string;
    /**
     * Plain text email body
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    bodyText?: string | null;
    /**
     * HTML email body
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    bodyHtml?: string | null;
    /**
     * Sender email address
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    fromEmail: string;
    /**
     * Sender display name
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    fromName?: string | null;
    /**
     * Gmail API message ID
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    gmailMessageId?: string | null;
    /**
     * Gmail API thread ID
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    gmailThreadId?: string | null;
    /**
     * 
     * @type {EmailStatus}
     * @memberof ClaimEmailWithRecipients
     */
    status: EmailStatus;
    /**
     * Error message if sending failed
     * @type {string}
     * @memberof ClaimEmailWithRecipients
     */
    errorMessage?: string | null;
    /**
     * When the email was actually sent
     * @type {Date}
     * @memberof ClaimEmailWithRecipients
     */
    sentAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimEmailWithRecipients
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimEmailWithRecipients
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Array<ClaimEmailRecipient>}
     * @memberof ClaimEmailWithRecipients
     */
    recipients: Array<ClaimEmailRecipient>;
    /**
     * 
     * @type {Array<ClaimEmailAttachment>}
     * @memberof ClaimEmailWithRecipients
     */
    attachments: Array<ClaimEmailAttachment>;
}



/**
 * Check if a given object implements the ClaimEmailWithRecipients interface.
 */
export function instanceOfClaimEmailWithRecipients(value: object): value is ClaimEmailWithRecipients {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('senderUserId' in value) || value['senderUserId'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('fromEmail' in value) || value['fromEmail'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('attachments' in value) || value['attachments'] === undefined) return false;
    return true;
}

export function ClaimEmailWithRecipientsFromJSON(json: any): ClaimEmailWithRecipients {
    return ClaimEmailWithRecipientsFromJSONTyped(json, false);
}

export function ClaimEmailWithRecipientsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimEmailWithRecipients {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'senderUserId': json['senderUserId'],
        'gmailAccountId': json['gmailAccountId'] == null ? undefined : json['gmailAccountId'],
        'direction': EmailDirectionFromJSON(json['direction']),
        'subject': json['subject'],
        'bodyText': json['bodyText'] == null ? undefined : json['bodyText'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'fromEmail': json['fromEmail'],
        'fromName': json['fromName'] == null ? undefined : json['fromName'],
        'gmailMessageId': json['gmailMessageId'] == null ? undefined : json['gmailMessageId'],
        'gmailThreadId': json['gmailThreadId'] == null ? undefined : json['gmailThreadId'],
        'status': EmailStatusFromJSON(json['status']),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'sentAt': json['sentAt'] == null ? undefined : (new Date(json['sentAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'recipients': ((json['recipients'] as Array<any>).map(ClaimEmailRecipientFromJSON)),
        'attachments': ((json['attachments'] as Array<any>).map(ClaimEmailAttachmentFromJSON)),
    };
}

export function ClaimEmailWithRecipientsToJSON(json: any): ClaimEmailWithRecipients {
    return ClaimEmailWithRecipientsToJSONTyped(json, false);
}

export function ClaimEmailWithRecipientsToJSONTyped(value?: Omit<ClaimEmailWithRecipients, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'senderUserId': value['senderUserId'],
        'gmailAccountId': value['gmailAccountId'],
        'direction': EmailDirectionToJSON(value['direction']),
        'subject': value['subject'],
        'bodyText': value['bodyText'],
        'bodyHtml': value['bodyHtml'],
        'fromEmail': value['fromEmail'],
        'fromName': value['fromName'],
        'gmailMessageId': value['gmailMessageId'],
        'gmailThreadId': value['gmailThreadId'],
        'status': EmailStatusToJSON(value['status']),
        'errorMessage': value['errorMessage'],
        'sentAt': value['sentAt'] == null ? undefined : ((value['sentAt'] as any).toISOString()),
        'recipients': ((value['recipients'] as Array<any>).map(ClaimEmailRecipientToJSON)),
        'attachments': ((value['attachments'] as Array<any>).map(ClaimEmailAttachmentToJSON)),
    };
}

